import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function InternalCommentSkeleton() {
    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <Skeleton variant="text" width={200} height={24} />
                    </div>
                    <div className="panel-body">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Skeleton variant="text" width="90%" height={18} />
                            <Skeleton variant="text" width="70%" height={18} />
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InternalCommentSkeleton;
